/**
 * Shared ceilings for public template semantic search.
 * Safe for client and server — no secrets, no I/O.
 */

export const TEMPLATE_SEARCH_MAX_QUERY_LENGTH = 500
export const TEMPLATE_SEARCH_MIN_QUERY_LENGTH = 2
export const TEMPLATE_SEARCH_DEBOUNCE_MS = 350
/** Matches `searchTemplates` top_k ceiling in `embed_index.ts`. */
export const TEMPLATE_SEARCH_MAX_LIMIT = 200
export const TEMPLATE_GALLERY_SEARCH_LIMIT = 48
export const TEMPLATE_EXPLORE_SEARCH_LIMIT = 80
export const TEMPLATE_AGENT_SEARCH_LIMIT = 8
export const TEMPLATE_AGENT_SEARCH_MAX = 20

/** Collection facets — user-only or curated (Flows) — never Turbopuffer attributes. */
export const USER_COLLECTION_TEMPLATE_TYPES = new Set([
  'forwarded',
  'sent',
  'flows',
])

/** Single public ANN endpoint shared by /templates, /browse/templates, /explore. */
export const PUBLIC_TEMPLATE_SEARCH_PATH = '/api/templates/explore/search'
/** The Flows pill's search endpoint — same machinery, flow cards back. */
